import { render, staticRenderFns } from "./empty-gem.vue?vue&type=template&id=263528ce&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../hoachipshop-ctv/admin-ctv/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../hoachipshop-ctv/admin-ctv/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
